"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeRemainingGenerator = exports.delay = void 0;
const delay = async (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
exports.delay = delay;
const timeRemainingGenerator = (durationMs) => {
    const expirationTime = new Date().getTime() + durationMs;
    return () => expirationTime - new Date().getTime();
};
exports.timeRemainingGenerator = timeRemainingGenerator;
//# sourceMappingURL=TimeUtils.js.map